import { FC } from 'react';

import { DIVIDERS } from '.';
import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

interface Props {
  image: ImageData;
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

/**
 * Settings Modal for VariationNeonTrivia
 * Wraps the shared SettingsModal with variation-specific configuration
 *
 * Before refactoring: 115 lines
 * After refactoring: ~35 lines (70% reduction)
 */
const SettingsModal: FC<Props> = ({ image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={withWatermarkDefaults(image)}
    title="Image Parameters"
    sections={[
      ...WATERMARK_SECTIONS,
      {
        title: 'Cover Divider',
        type: 'radio',
        stateKey: 'divider',
        options: DIVIDERS,
      },
    ]}
  />
);

export default SettingsModal;
